// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ewk51s {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3) 0;
  min-height: 100%;
  background-color: var(--background-alt);
}

.PCVtQN {
  display: flex;
  gap: var(--spacing-3);
  flex: 1;
  align-items: stretch;
  min-height: 0;
}

.PCVtQN._K0RtN {
  justify-content: center;
}

.PCVtQN._K0RtN .VrXIAI {
  max-width: 1200px;
}

.VrXIAI {
  flex: 1;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
  min-height: 0;
}

.VrXIAI.WxbRHI {
  background: transparent;
  box-shadow: none;
  border: none;
  overflow: inherit;
}

.vluYot {
  width: 320px;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  max-height: 100%;
  overflow-y: auto;
}

@media (max-width: 1024px) {
  .PCVtQN {
    flex-direction: column;
  }

  .vluYot {
    width: 100%;
    order: -1;
  }
}

@media (max-width: 768px) {
  .ewk51s {
    padding: var(--spacing-2);
    gap: var(--spacing-2);
  }

  .PCVtQN {
    gap: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/ContentLayout/ContentLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,OAAO;EACP,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,wCAAwC;EACxC,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".contentLayout {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3) 0;\n  min-height: 100%;\n  background-color: var(--background-alt);\n}\n\n.cardsContainer {\n  display: flex;\n  gap: var(--spacing-3);\n  flex: 1;\n  align-items: stretch;\n  min-height: 0;\n}\n\n.cardsContainer.singleColumn {\n  justify-content: center;\n}\n\n.cardsContainer.singleColumn .mainCard {\n  max-width: 1200px;\n}\n\n.mainCard {\n  flex: 1;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-card);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 0;\n  min-height: 0;\n}\n\n.mainCard.noBackground {\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  overflow: inherit;\n}\n\n.sidebarCard {\n  width: 320px;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-card);\n  display: flex;\n  flex-direction: column;\n  align-self: flex-start;\n  max-height: 100%;\n  overflow-y: auto;\n}\n\n@media (max-width: 1024px) {\n  .cardsContainer {\n    flex-direction: column;\n  }\n\n  .sidebarCard {\n    width: 100%;\n    order: -1;\n  }\n}\n\n@media (max-width: 768px) {\n  .contentLayout {\n    padding: var(--spacing-2);\n    gap: var(--spacing-2);\n  }\n\n  .cardsContainer {\n    gap: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentLayout": `ewk51s`,
	"cardsContainer": `PCVtQN`,
	"singleColumn": `_K0RtN`,
	"mainCard": `VrXIAI`,
	"noBackground": `WxbRHI`,
	"sidebarCard": `vluYot`
};
module.exports = ___CSS_LOADER_EXPORT___;
